import { render, staticRenderFns } from "./GroupMissionTasks.vue?vue&type=template&id=54cc1cfc&"
import script from "./GroupMissionTasks.vue?vue&type=script&lang=js&"
export * from "./GroupMissionTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports